import {useEffect, useState} from "react";
import HomeRight from "../../../../assets/images/home_right.png"
import CheckCircleIcon from "../../../../assets/images/circle-check.png"
import DashedCircleIcon from "../../../../assets/images/dashed-check.png"
import GreatIcon from "../../../../assets/images/icon-great.png"
import BadIcon from "../../../../assets/images/icon-bad.png"
import ArrowDownIcon from "../../../../assets/images/arrow-down.png"
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {deleteHomework} from "../../../../network/Endpoint";
import {messageToast} from "../../../../components/Toast";
import Modal from "../../../../components/Modal";
import Button from "../../../classStudentManagement/components/Button";

const StageBadgeHomework = ({index, grade, semester, stageSummary, classInfo, notStartedComment, onAssignHomework, homeworkStageIds, fetchGetClassHomework,setHomeworkStageIds}) => {

    const [stageInfo, setStageInfo] = useState(null);
    const [lessonInfo, setLessonInfo] = useState(null);
    const [notStartedStudents, setNotStartedStudents] = useState([]);
    const [completedStudents, setCompletedStudents] = useState([]);
    const [guidanceNeededStudents, setGuidanceNeededStudents] = useState([]);
    const [activeDate, setActiveDate] = useState(null);
    const [showTooltip, setShowTooltip] = React.useState(false); // 툴팁 상태 관리
    const [showTooltipGuidanceNeeded, setShowTooltipGuidanceNeeded] = React.useState(false); // 툴팁 상태 관리
    const [onHomework, setOnHomework] = useState(false);
    const navigate = useNavigate();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);


    const thumbNailDomain = "https://sym008463-sym008463.ktcdn.co.kr/stage_thumbnails/";

    const getThumbnailUrl = (fileName) => {
        return thumbNailDomain+fileName+".png";
    }

    const lessonDetail = () => {
        navigate("/page/classHomeworkStage?classId="+classInfo.classId+"&stageId="+stageInfo.stageId+"&lessonInfoId="+lessonInfo.lessonInfoId)
    }

    const setHomework = () => {
        if(onHomework){
            setHomeworkStageIds(homeworkStageIds.filter(homeworkStageId => homeworkStageId !== stageInfo.stageId));
            setOnHomework(false);
        }else{
            setHomeworkStageIds([...homeworkStageIds, stageInfo.stageId]);
            setOnHomework(true);
        }
    }

    const handleDeleteStudent = () => {
        fetchDeleteHomework();
        setIsDeleteModalOpen(false);
    };

    // 서버에 숙제 저장
    const fetchDeleteHomework = async () => {
        try {
            const stageIdArray = [stageInfo.stageId];
            const body = {
                classId: classInfo.classId,
                lessonInfoId: lessonInfo.lessonInfoId,
                homeworkDays: 6,
                stageIds : stageIdArray
            };
            const res = await deleteHomework(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                let msgDescription = "숙제 취소가 완료되었습니다."
                messageToast({message : "숙제 취소 완료", description : msgDescription});
                fetchGetClassHomework();    // 숙제 저장후 현 단원 숙제 정보 다시 가져와서 갱신하기
            } else {
                alert(`ERROR: 숙제 취소중 오류가 발생했어요. \n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('숙제 취소중 오류가 발생했어요. \n아크수학으로 문의해 주세요.');
        }
    }


    useEffect(() => {
        if(stageSummary){
            setStageInfo(stageSummary.stageInfo);
            setLessonInfo(stageSummary.lessonInfo);
            setNotStartedStudents(stageSummary.notStartedStudents);
            setCompletedStudents(stageSummary.completedStudents);
            setGuidanceNeededStudents(stageSummary.guidanceNeededStudents);
            setActiveDate(stageSummary.activeDate);
        }
    }, [stageSummary]);

    useEffect(() => {
        if(onAssignHomework){
            setOnHomework(false);
        }
    }, [onAssignHomework]);


    return (
        <div className="flex flex-col w-full max-w-[510px] mb-5 relative">
            <div
                className="flex items-center gap-[9px] rounded-t-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom pt-[14px] pb-[13px] px-[13px]">
                <div
                    className="flex justify-center items-center text-[#BEC3CF] text-[17px] text-center font-[700] w-[30px] h-[30px] border-[2px] border-[#BEC3CF] rounded-full px-2">
                    {index + 1}
                </div>
                <div className="flex justify-between items-center w-full">
                    <div className="items-center text-[#50555F] text-[17px] font-[700] w-[330px]  truncate whitespace-nowrap overflow-hidden text-left">
                        {stageInfo && stageInfo.stageName}
                    </div>
                    {/*숙제를 낸적이 있을때*/}
                    {stageSummary && stageSummary.activeDate !== null && (
                        <div
                            className="flex flex-row w-max min-w-[100px] justify-end items-center text-[#50555F] text-[14px] font-[800] cursor-pointer h-[18px] gap-[6px]"
                            onClick={lessonDetail}
                        >
                            <div className=" flex justify-end  items-center pb-[1px]">상세보기</div>

                            <img
                                src={HomeRight}
                                alt="right"
                                className="ml-1 w-[8px] items-center"
                            />
                        </div>
                    )}
                </div>

            </div>
            <div
                className="flex justify-between items-center rounded-b-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom px-[17px] pt-[16px] pb-[15px] mt-[-1px]">
                <div className="flex justify-center items-center gap-5">
                    <img
                        className=" w-[154px] h-[92px] rounded-[10px]"
                        src={stageInfo && getThumbnailUrl(stageInfo.thumbNail)}
                        alt="stage thumbnail"></img>

                </div>
                {stageSummary && stageSummary.activeDate !== null ? (
                    <div className="inline-flex items-center">
                        <div
                            className={`flex flex-col w-[72px] gap-[4px] items-center justify-center relative ${notStartedStudents.length > 0 && 'cursor-zoom-in'}`}
                            onMouseEnter={() => notStartedStudents && notStartedStudents.length > 0 && setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                        >
                            <img className="w-[28px]" src={DashedCircleIcon} alt="check-circle"/>
                            <div className="flex flex-col">
                                <div className="text-[#50555F] text-[16px] font-[700]">미진행</div>
                                <div className="text-[#7494FF] text-[16px] font-[700]">
                                    {notStartedStudents && notStartedStudents.length}명
                                </div>
                            </div>
                            {/* 툴팁 표시 */}
                            {showTooltip && notStartedStudents && notStartedStudents.length > 0 && (
                                <div
                                    className="absolute mt-[-104px] -translate-y-1/2 left-[50%] transform -translate-x-1/2 bg-black text-white text-xs rounded-md p-2 shadow-lg z-10 max-w-[150px] text-center">
                                    <div className="whitespace-nowrap overflow-ellipsis overflow-hidden">
                                        {notStartedStudents.map((student, index) => index < 4 ? (
                                            <div key={index}>{student}</div>
                                        ) : "")}
                                        {notStartedStudents.length > 4 && "..."}
                                    </div>
                                    <img
                                        src={ArrowDownIcon}
                                        alt="arrow down icon"
                                        className="absolute bottom-[-10px] left-[50%] -translate-x-1/2 w-[8px]"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="flex border-[1px] border-[#EAEAEA] h-[82px]"></div>

                        <div className="flex flex-col w-[72px] gap-[3px] items-center justify-center">
                            <img className="w-[28px]" src={CheckCircleIcon} alt="check-circle"/>
                            <div className="flex flex-col">
                                <div className="text-[#50555F] text-[16px] font-[700]">학습완료</div>
                                <div className="text-[#7494FF] text-[16px] font-[700]">
                                    {completedStudents && completedStudents.length}명
                                </div>
                            </div>
                        </div>

                        <div className="flex border-[1px] border-[#EAEAEA] h-[82px]"></div>

                        {completedStudents && completedStudents.length > 0 ? (
                            guidanceNeededStudents && guidanceNeededStudents.length > 0 ? (
                                <div
                                    className={`flex flex-col w-[72px] gap-[3px] items-center justify-center relative ${guidanceNeededStudents.length > 0 && 'cursor-zoom-in'}`}
                                    onMouseEnter={() => guidanceNeededStudents && guidanceNeededStudents.length > 0 && setShowTooltipGuidanceNeeded(true)}
                                    onMouseLeave={() => setShowTooltipGuidanceNeeded(false)}
                                >
                                    <img className="w-[28px]" src={BadIcon} alt="check-circle"/>
                                    <div className="flex flex-col">
                                        <div className="text-[#50555F] text-[16px] font-[700]">어려워요</div>
                                        <div className="text-[#FC5955] text-[16px] font-[700]">
                                            {guidanceNeededStudents && guidanceNeededStudents.length}명
                                        </div>
                                    </div>
                                    {/* 툴팁 표시 */}
                                    {showTooltipGuidanceNeeded && guidanceNeededStudents && guidanceNeededStudents.length > 0 && (
                                        <div
                                            className="absolute mt-[-104px] -translate-y-1/2 left-[50%] transform -translate-x-1/2 bg-black text-white text-xs rounded-md p-2 shadow-lg z-10 max-w-[150px] text-center">
                                            <div className="whitespace-nowrap overflow-ellipsis overflow-hidden">
                                                {guidanceNeededStudents.map((student, index) => index < 4 ? (
                                                    <div key={index}>{student}</div>
                                                ) : "")}
                                                {guidanceNeededStudents.length > 4 && "..."}
                                            </div>
                                            <img
                                                src={ArrowDownIcon}
                                                alt="arrow down icon"
                                                className="absolute bottom-[-10px] left-[50%] -translate-x-1/2 w-[8px]"
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="flex flex-col w-[72px] gap-[3px] items-center justify-center">
                                    <img className="w-[28px]" src={GreatIcon} alt="check-circle"/>
                                    <div className="flex flex-col">
                                        <div className="text-[#50555F] text-[16px] font-[700]">모두</div>
                                        <div className="text-[#50555F] text-[16px] font-[700]">잘했어요</div>
                                    </div>
                                </div>
                            )
                        ) : (
                            <div className="flex flex-col w-[72px] gap-[3px] items-center justify-center">
                                -
                            </div>
                        )}

                        <div className="flex border-[1px] border-[#EAEAEA] h-[82px]"></div>
                        <div className="flex flex-col w-[72px] gap-[3px] items-center justify-center text-[14px] font-[700]">
                            {stageSummary && stageSummary.leftHomeworkDate > 3 ? (
                                <div className="flex flex-col gap-[10px]">
                                    <div className="flex w-[50px] h-[29px] items-center justify-center rounded-[7px] bg-[#FFF6E2] text-[#FF8C00]">
                                        D-{stageSummary.leftHomeworkDate}
                                    </div>
                                    <div
                                        onClick={() => setIsDeleteModalOpen(true)}
                                        className="flex w-[50px] h-[29px] items-center justify-center rounded-[7px] bg-[#7494FF] text-[#FFFFFF] cursor-pointer">
                                        취소
                                    </div>
                                </div>
                            ) : (stageSummary.leftHomeworkDate > 0 ? (
                                <div className="flex flex-col gap-[10px]">
                                    <div
                                        className="flex w-[50px] h-[29px] items-center justify-center rounded-[7px] bg-[#FED7D8] text-[#FC5955]">
                                        D-{stageSummary.leftHomeworkDate}
                                    </div>
                                    <div
                                        onClick={() => setIsDeleteModalOpen(true)}
                                        className="flex w-[50px] h-[29px] items-center justify-center rounded-[7px] bg-[#7494FF] text-[#FFFFFF] cursor-pointer">
                                        취소
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="flex w-[50px] h-[29px] items-center justify-center rounded-[7px] bg-[#D1F4DE] text-[#009C5B]">
                                    종료
                                </div>
                            ))}
                        </div>


                    </div>
                ) : (
                    <div className="text-[#B0B2B8] text-[16px] font-[700] w-[216px]">{notStartedComment}</div>
                )}
            </div>
            {onAssignHomework && onAssignHomework===true && stageSummary.leftHomeworkDate <=0 && (
                <div
                    className={`absolute w-full h-full bg-[#FFFFFF] rounded-[20px] border-[5px] cursor-pointer ${onHomework ? "bg-opacity-0 border-[#7494FF]" : "bg-opacity-50 border-[#E9E9E9]"}`}
                    onClick={() => setHomework()}
                >
                </div>
            )}

            {/* 삭제 확인 모달 */}
            <Modal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
            >
                <h2 className="text-[28px] font-[700] mb-3">숙제 취소</h2>
                <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
                <div className="my-8 text-2xl font-normal">
                    <div className="text-base w-full leading-tight">숙제를 취소 하시겠습니까? <br/></div>
                </div>
                <div className="flex justify-center gap-4">
                    <Button
                        label="취소"
                        className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsDeleteModalOpen(false)}
                    />
                    <Button label="삭제하기" onClick={handleDeleteStudent}/>
                </div>
            </Modal>
        </div>
    )
}


export default StageBadgeHomework;